export type FormType =
  | 'createPatient'
  | 'editPatient'
  | 'createVisit'
  | 'editVisit'
  | 'createMeeting'
  | 'createEvent'
  | 'createUser'
  | 'editUser'
  | 'createRole'
  | 'editRole'
  | 'createSubtenant'
  | 'editSubtenant'
  | 'importFromMiniscreen'
  | 'createDataBlockType'
  | 'createDataBlockField'
  | 'editDataBlockField'
  | 'editDataBlock'
  | 'editDataBlockStatistic'
  | 'createDataBlockStatistic'
  | 'createDataBlock'
  | 'createDoctor'
  | 'editDoctor'
  | 'appointmentColorSettings'
  | 'hl7Filter'
  | 'createResource'
  | 'editResource'
  | 'changeOwnPassword'
  | 'changeLanguage'
  | 'setPassword'
  | 'importDocument'
  | 'importMeasurementFiles'
  | 'importGDTFile'
  | 'mergeField'
  | 'createDictionaryRecord'
  | 'editDictionaryRecord'
  | 'configureCustomDictionary'
  | 'createCustomDictionaryItem'
  | 'editCustomDictionaryItem'
  | 'createCalendarConfiguration'
  | 'editCalendarConfiguration'
  | 'createPatientListConfiguration'
  | 'editPatientListConfiguration'
  | 'mergePair'
  | 'manageGDTMappings'
  | 'sendViaGDT'
  | 'selectVisits'
  | 'createAbsence'
  | 'editAbsence'
  | 'createNote'
  | 'editNote'
  | 'fileVersionHistory'
  | 'createVisitType'
  | 'editVisitType'
  | 'editInputTemplates'
  | 'reimportMeasurements'
  | 'mergePatientWithCardData'
  | 'mergeInsuranceCardData'
  | 'copyDataBlockFieldValue'
  | 'createCodePrefix'
  | 'sendTestMessage';

export interface StateSettings {
  isNormal: boolean;
  isHidden: boolean;
  isExpanded: boolean;
}

export const defaultForm: StateSettings = {
  isNormal: true,
  isHidden: true,
  isExpanded: true,
};

export const expandedOnlyForm: StateSettings = {
  isNormal: false,
  isHidden: false,
  isExpanded: true,
};

export const expandedForm: StateSettings = {
  isNormal: false,
  isHidden: true,
  isExpanded: true,
};

export const normalForm: StateSettings = {
  isNormal: true,
  isHidden: true,
  isExpanded: false,
};

export interface Form {
  id: number;
  type: FormType;
  title?: string;
  stateSettings: StateSettings;
  additionalFormProps?: { [key in string]: unknown };
  state: WindowState;
  isHidden: boolean;
  isBeingCompleted?: boolean;
  resolve?: (result: any | undefined) => void;
  formDirtyStateRetriever?: () => boolean;
  isLoading?: boolean;
  loadingTitle?: string;
  isCloseButtonHidden: boolean;
}

export type WindowState = 'normal' | 'expanded';

export interface FormComponentProps {
  formType: FormType;
  formId: number;
  isExpanded: boolean;
  closeForm: (formId: number) => void;
  tryCompleteForm: (
    formType: FormType,
    formId: number,
    submitProcess: () => Promise<any>,
    title?: string,
  ) => Promise<void>;
  registerFormDirtyStateRetriever: (
    formId: number,
    retriever: () => boolean,
  ) => void;
  expand: (formId: number) => void;
  loadBlocking: (
    formId: number,
    title: string,
    load: () => Promise<any>,
  ) => Promise<void>;
  changeFormTitle: (formId: number, newTitle: string) => void;
  setIsCloseButtonHidden: (
    formId: number,
    isCloseButtonHidden: boolean,
  ) => void;
}
